import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, resolveComponent as _resolveComponent, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-21be775e"),n=n(),_popScopeId(),n)
const _hoisted_1 = ["src", "alt"]
const _hoisted_2 = { class: "top-user__nickname" }
const _hoisted_3 = { class: "top-user__likes" }
const _hoisted_4 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("svg", {
  width: "16",
  height: "16",
  viewBox: "0 0 24 24",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
}, [
  /*#__PURE__*/_createElementVNode("path", {
    "fill-rule": "evenodd",
    "clip-rule": "evenodd",
    d: "M7.27245 5C4.91284 5 3 6.91284 3 9.27246V9.48674C3 10.6548 3.45553 11.7768 4.26977 12.6143L11.7968 20.3565C11.9081 20.4709 12.0919 20.4709 12.2032 20.3565L19.7302 12.6143C20.5445 11.7768 21 10.6548 21 9.48674V9.27245C21 6.91284 19.0872 5 16.7275 5C15.5736 5 14.4686 5.46681 13.6642 6.29422L12.7764 7.20739C12.3512 7.64476 11.6488 7.64476 11.2236 7.20739L10.3358 6.29422C9.53136 5.46681 8.42644 5 7.27245 5ZM1 9.27246C1 5.80828 3.80827 3 7.27245 3C8.96664 3 10.5888 3.68533 11.7698 4.90006L12 5.13687L12.2302 4.90006C13.4112 3.68534 15.0334 3 16.7275 3C20.1917 3 23 5.80827 23 9.27245V9.48674C23 11.1755 22.3414 12.7977 21.1642 14.0085L13.6371 21.7506C12.7405 22.6729 11.2595 22.6729 10.3629 21.7506L2.83578 14.0085C1.65859 12.7977 1 11.1755 1 9.48674V9.27246Z",
    fill: "white"
  })
], -1))
const _hoisted_5 = { class: "top-user__likes_text" }


export default /*#__PURE__*/_defineComponent({
  __name: 'BaseTopUser',
  props: {
    user: {},
    likes: {}
  },
  setup(__props: any) {



return (_ctx: any,_cache: any) => {
  const _component_RouterLink = _resolveComponent("RouterLink")!

  return (_openBlock(), _createBlock(_component_RouterLink, {
    to: `/profile/user?id=${_ctx.user.id}`,
    class: "top-user"
  }, {
    default: _withCtx(() => [
      _createElementVNode("img", {
        src: _ctx.user.avatar,
        alt: _ctx.user.nickname,
        class: "top-user__avatar"
      }, null, 8, _hoisted_1),
      _createElementVNode("p", _hoisted_2, _toDisplayString(_ctx.user.nickname), 1),
      _createElementVNode("div", _hoisted_3, [
        _hoisted_4,
        _createElementVNode("p", _hoisted_5, _toDisplayString(_ctx.likes), 1)
      ])
    ]),
    _: 1
  }, 8, ["to"]))
}
}

})